import { createAsyncThunk } from '@reduxjs/toolkit';

import { sendSentryClientErrorOnce } from 'shared/lib';
import type { TLoansFirstTouchClient } from 'shared/types/TLoansService';

import { resolveStParentIdThunk } from 'entities/st-tracking';
import { userDeviceIdSelector } from 'entities/user';
import { collectWLOtherDataSelector } from 'entities/whiteLabels';

import { sendLoansFirstTouchApi } from '../model/sendLoansFirstTouch.query';

export const sendFirstTouchThunk = createAsyncThunk<
  void,
  Pick<TLoansFirstTouchClient, 'sourceUrl'>,
  { state: Pick<Store, 'user' | 'whiteLabel'> }
>('sendLoansFirstTouch/sendLoansFirstTouchThunk', async (payload, { dispatch, getState }) => {
  const { sourceUrl } = payload;
  const deviceId = userDeviceIdSelector(getState());
  const { affId, offerId } = collectWLOtherDataSelector(getState());

  const stParentId = await dispatch(
    resolveStParentIdThunk({
      sourceUrl,
      affId,
      offerId: offerId?.toString(),
    }),
  ).unwrap();

  try {
    await dispatch(
      sendLoansFirstTouchApi.endpoints.sendLoansFirstTouch.initiate({
        sourceUrl,
        deviceId,
        other: stParentId ? { stParentId } : undefined,
      }),
    ).unwrap();
  } catch (error) {
    sendSentryClientErrorOnce('sendLoansFirstTouchThunk', error);
  }
});
